import React from 'react';
import Cookies from 'universal-cookie';
import API from '../../configAPI';
import APP_CONFIG from '../../config';
import BarLoader from 'react-spinners/BarLoader';

const cookies = new Cookies();

class Productos_pe extends React.Component{
    constructor(props){
        super(props);
        this.state={
            id:cookies.get("id"),
            name:"a",
            last_name:"",
            email:"",
            phone_number:"",
            address:"",
            pais:"",
            distrito:"",
            products: [],
            compra: [],
            distrito:0,
            loading: true,
            message:'',   
            message_serve:''  
        }
    }
    
    componentDidMount() {
        if(cookies.get('id')){
            this.getProduct();
        }else{
            window.location.href="/";
        }

    }
    

    getProduct = () =>{
        this.setState({loading: true});

        API.PRODUCTS.post(`pedidos_compra_details/${this.props.match.params.product}`,{
            id:this.state.id,
        })
        .then(resp =>{
            this.setState({
                products:resp.data,
                compra:resp.data[0].compra
            });
            console.log(this.state.products);
            console.log(this.state.compra);
        })
        .catch(err =>{
            console.log("ERROR");
            console.log(err);
        });
    }

    render(){
        return(
            
            <div className="container-fluid mt-2 mb-3">
                <div className="col-12">
                    <div className="col-md-10 col-sm-12 mx-auto"> 
                        
                        <div className="col-md-12 col-sm-12 border-solid">
                            
                            <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active datos-div" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <p className="editar-text">Pedido Nro: {this.state.compra.id+992589}</p>   
                                <hr></hr>
                                <p className="text-datos">Lista de productos</p>
                                
                                <table className="table">
                                <thead>
                                    <tr>
                                    <th style={{width:"25%"}}>Producto</th>
                                    <th style={{width:"15%"}}>Precio unitario</th>
                                    <th style={{width:"10%"}}>Cantidad</th>
                                    <th style={{width:"15%"}}>Envío</th>
                                    <th style={{width:"15%"}}>Estado</th>
                                    <th style={{width:"15%"}}>Sub total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.products.map((prod,index) =>(
                                    <tr key={index}> 
                                            <td >
                                            <div className="product_car">
                                                <div className="img">
                                                    <a href={"/producto/"+prod.producto.slug}><img src={prod.producto.product_images[0].url_image} width="100%"></img></a>
                                                
                                                </div>

                                                <div className="text">
                                                    <h5>{prod.producto.name}</h5>
                                                    <p style={{fontWeight:"700"}}>{prod.producto.provider.name}</p>
                                                    {prod.descuento>0?
                                                    <span style={{color:"#009c02",fontWeight:"700"}}><span className="descuento_pd">- {prod.descuento} %</span> ahorras: S/. {(prod.producto.price - prod.producto.fair_price).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span>
                                                    :
                                                    ""
                                                    }
                                                    
                                                    </div>
                                            </div>
                                        </td>
                                    <td >
                                       
                                        {prod.descuento>0?  
                                        <p>
                                        <span className="precio_prod">S/. {prod.fair_price}</span>
                                        <span className="fair_precio_prod"> {prod.price}</span>
                                        </p>
                                        :
                                        <p>
                                        <span className="precio_prod">S/. {prod.price}</span>
                                        </p>
                                        }   
                                        
                                    </td>
                                        <td className="cantidad">{prod.cantidad}</td>
                                    <td >
                                        {prod.precio_envio>0?
                                        <p>{prod.precio_envio}</p>
                                        :
                                        <p style={{color:"#009c02",fontWeight:"700"}}>GRATIS</p>
                                        }
                                        
                                    </td>

                                    <td>
                                            {prod.compra_estado_id==1
                                            ? 
                                            <p className="estado es_s">{prod.estado.nombre}</p>
                                            :
                                            prod.compra_estado_id==2
                                            ? 
                                            <p className="estado es_e">{prod.estado.nombre}</p>
                                            :
                                            prod.compra_estado_id==3
                                            ?
                                            <p className="estado es_en">{prod.estado.nombre}</p>
                                            :
                                            <p className="estado es_a">{prod.estado.nombre}</p>
                                            }
                                    </td>

                                    <td >
                                    {prod.descuento>0? 
                                      <p style={{fontWeight:"700"}} >S/. {((prod.fair_price*prod.cantidad)+Number(prod.precio_envio)).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</p>
                                    :
                                      <p style={{fontWeight:"700"}} >S/. {((prod.price*prod.cantidad)+Number(prod.precio_envio)).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</p>
                                    }
                                        
                                    </td>
                                     
                                       
                                    </tr>
                                    ))}   

                                    <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="total">Total: </td>
                                    <td className="total" >S/. {this.state.compra.amount}   </td>
                                    </tr>
                                   
                                </tbody>
                                </table>
                                

                                
                            </div>
                            </div>
                        </div>
                       
                    </div> 
                   
                </div>
            </div>
           
        );
    
}

}
export default Productos_pe;